export default __webpack_public_path__ + "media/music/849b23dbee0dcf04543df7cf5d3fc555.mp3";